module.exports = __webpack_public_path__ + "static/media/m-1-02.d15686c2.svg";